import { selectDoc, event, addClass, removeClass } from "../utils/utils";
import $ from "jquery";

export class Header {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.body = document.body;
    this.headerContainer = selectDoc(".section-header");
    this.headerChildren = this.headerContainer.children[0];
    this.headerSpacer = selectDoc(".header-spacer");
  }

  render() {
    this.getScrollPosition();
    this.updateCart();
  }

  getScrollPosition = () => {
    const headerContainer = this.headerContainer;
    const headerChildren = this.headerChildren;
    const isCollection =
      document.getElementsByClassName("main-collection-template").length > 0;

    let oldValue = 0;
    let newValue = 0;
    window.addEventListener("scroll", () => {
      scrollHandler();
    });
    
    scrollHandler();

    function scrollHandler() {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      newValue = window.pageYOffset;
      if (oldValue < newValue) {
        const topOffset = window.screen.width > 768 ? 30 : 10;
        if(top > topOffset){
          // addClass(headerContainer, "animation-up");
          addClass(headerContainer, "with-background");
          removeClass(headerChildren, "main-header--white-icons");
        }
      } else if (oldValue > newValue) {
        // if (top < 80 && isCollection) {
        //   removeClass(headerContainer, "with-background");
        //   removeClass(headerChildren, "main-header--white");
        //   addClass(headerChildren, "main-header--white-icons");
        // }

        // if (top > 63 && isCollection) {
        //   addClass(headerChildren, "main-header--white");
        //   addClass(headerContainer, "with-background");
        //   //removeClass(headerContainer, "animation-up");
        //   removeClass(headerChildren, "main-header--white-icons");
        // }

        // if (top >= 0 && !isCollection) {
        //   //removeClass(headerContainer, "animation-up");
        //   addClass(headerContainer, "with-background");
        // }

        if (top > 0) {
          addClass(headerContainer, "with-background");
          //removeClass(headerContainer, "animation-up");
        }
      }
      oldValue = newValue;
    }
  };

  updateCart = () => {
    const $elQtyContainer = $("[data-cart-qty]");
    if (window.thisCart.item_count > 0) {
      $elQtyContainer.html(window.thisCart.item_count);
    }
  };


}
